// extracted by mini-css-extract-plugin
export var aboutCard = "index-module--aboutCard--1ecd1";
export var aboutQuote = "index-module--aboutQuote--4a5d7";
export var bgImage = "index-module--bgImage--2c4e4";
export var bigLogo = "index-module--bigLogo--25782";
export var button = "index-module--button--2b1dd";
export var container = "index-module--container--d86ba";
export var content = "index-module--content--ed694";
export var decor = "index-module--decor--3e878";
export var decorBox = "index-module--decorBox--1e962";
export var decorBoxWrapper = "index-module--decorBoxWrapper--d2856";
export var eighthImage = "index-module--eighthImage--0bbe4";
export var fadeInUp = "index-module--fadeInUp--ae2c9";
export var fadeInZoom = "index-module--fadeInZoom--6f1fb";
export var fifthImage = "index-module--fifthImage--ae589";
export var firstImage = "index-module--firstImage--db6af";
export var fourthImage = "index-module--fourthImage--93720";
export var heading = "index-module--heading--b96f6";
export var image = "index-module--image--99358";
export var isVisible = "index-module--isVisible--18b04";
export var lineAbove = "index-module--lineAbove--b8208";
export var mobile = "index-module--mobile--52c85";
export var name = "index-module--name--adab4";
export var overlay = "index-module--overlay--a5bdc";
export var relativeWrapper = "index-module--relativeWrapper--606e0";
export var reverse = "index-module--reverse--65b56";
export var row = "index-module--row--ed284";
export var second = "index-module--second--5036a";
export var secondImageContainer = "index-module--secondImageContainer--094ce";
export var seventhImage = "index-module--seventhImage--49493";
export var sixthImage = "index-module--sixthImage--3d00b";
export var teamImage = "index-module--teamImage--54599";
export var teamImages = "index-module--teamImages--6b1d5";
export var text = "index-module--text--92e65";
export var thirdImage = "index-module--thirdImage--4466e";